import { render } from "./ReceitasFilters.vue?vue&type=template&id=6dfaa805"
import script from "./ReceitasFilters.vue?vue&type=script&lang=js"
export * from "./ReceitasFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__